export default "__VITE_ASSET__CPyivfZY__"